export default {
  state: {
    sendVal: '',
    sendedVal: '',
    loadingDialog: false
  },
  mutations: {
    SET_POP_SEND_VAL: (state, sendVal) => {
      state.sendVal = sendVal
    },
    SET_POP_SENDED_VAL: (state, sendedVal) => {
      state.sendedVal = sendedVal
    },
    SET_LOADING_DIALOG: (state, visible) => {
      state.loadingDialog = visible
    }
  },
  actions: {
    SendParam({ commit }, to) {
      // API를 통해 입력 받은 ID/Password 정보를 입력한다.
      commit('SET_POP_SEND_VAL', to.sendVal)
      commit('SET_POP_SENDED_VAL', to.sendedVal)
    },
    SetLoadingDialog({ commit }, visible) {
      commit('SET_LOADING_DIALOG', visible)
    }
  }
}
